import get from 'lodash/get';
import isNil from 'lodash/isNil';

type ColumnConfigItem<T> = {
  header: string;
  map?: (val: T) => string;
};

type ColumnConfig<T> = {
  [K in keyof T]?: ColumnConfigItem<T[K]> | string;
};

type DescriptionItem = {
  name: string;
  description: string;
};

export const toCsv = <T>(
  cfg: ColumnConfig<T>,
  data: T[],
  description: DescriptionItem[] = []
): string => {
  // Data
  const csv = data.map((entity) =>
    Object.entries<ColumnConfigItem<unknown>>(
      cfg as Record<string, ColumnConfigItem<unknown>>
    )
      .map(([propKey, configItem]) => {
        const value = get(entity, propKey);
        if (typeof configItem === 'object' && configItem.map) {
          return `"${configItem.map(value)}"`;
        }
        // Exclude all empty values
        return !isNil(value) ? `"${value}"` : '';
      })
      .join(';')
  );

  // Header
  csv.unshift(
    Object.entries(cfg as Record<string, ColumnConfigItem<unknown>>)
      .map(([_, val]) => `"${typeof val === 'string' ? val : val.header}"`)
      .join(';')
  );

  // Description
  if (description.length) {
    const paddingFromLeft =
      csv.length > 0
        ? Array(Object.keys(cfg).length).fill(';').join('') + ';'
        : '';
    description.forEach(({ name, description }: DescriptionItem, index) => {
      if (index === 0) {
        // Header
        if (csv[0]) {
          csv[0] += ';;name;description';
        } else {
          csv.push('name;description');
        }
      }
      if (csv[index + 1]) {
        csv[index + 1] += `;;"${name}";"${description}"`;
      } else {
        csv.push(`${paddingFromLeft}"${name}";"${description}"`);
      }
    });
  }

  return csv.join('\r\n');
};
